<template>
<div class="form-group">
    <label class="label-control" v-if="label" :for="id">{{ label }}:</label>
    <select class="form-control" :id="id" v-model="model" required>
        <option :disabled="required" :value="placeholder" :key="0">{{ placeholder }}</option>
        <option v-for="(option, index) in options" :value="option" :key="index + 1">
            {{ option }}
        </option>
    </select>
</div>
</template>

<script>
export default {
    name: 'SelectOption',
    props: {
        label: {
            type: String,
        },
        id: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
            default: '',
        },
        options: {
            type: Array,
            required: true,
        },
        value: {
            type: [String, Number],
            default: '',
        },
        required: {
            type: Boolean,
            default: true,
        },
        formInputResetFlag: Boolean,
    },
    updated() {
        this.model = this.value;
    },
    data() {
        return {
            model: this.value,
        }
    },
    watch: {
        model: function () {
            this.$emit('input', this.model);
        },
        formInputResetFlag: function () {
            this.model = this.placeholder;
        }
    }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// SelectOption.vue?79096ab0